<div class="card card-box mb-5">
  <div class="card-header py-3">
    <div class="card-header--title font-size-lg">
      <b><i class="fas fa-cog"></i> Booking </b>
    </div>
    <div class="card-header--actions">
      <!--      <button class="btn btn-sm btn-neutral-secondary" type="button" (click)="createModal()">-->
      <!--                <span class="btn-wrapper&#45;&#45;icon">-->
      <!--                    <fa-icon [icon]="['fas', 'plus-circle']" class="text-success"></fa-icon>-->
      <!--                </span>-->
      <!--        <span class="btn-wrapper&#45;&#45;label">-->
      <!--                    New User-->
      <!--                </span>-->
      <!--      </button>-->
    </div>
  </div>
  <!--  <div class="d-flex justify-content-between px-4 py-3">-->
  <div class="search-wrapper m-3">
    <div class="row">
      <div class="col-3">
        <label for="cname">Client Name</label>
        <input id="cname" class="form-control" type="text">
      </div>
      <div class="col-3">
        <label for="email">Email</label>
        <input id="email" class="form-control" type="text">
      </div>
      <div class="col-3">
        <label for="email">Email</label>
        <input class="form-control" type="text">
      </div>
      <div class="col-3">
        <button class="btn btn-info" style="margin-top: 28px;">Search</button>
      </div>
    </div>
  </div>
  <!--  </div>-->
  <div class="divider"></div>
  <div class="table-responsive">
    <table class="table table-hover text-nowrap mb-0">
      <thead>
      <tr>
        <th class="bg-white text-center">REF</th>
        <th class="bg-white text-center">CLIENT</th>
        <th class="bg-white text-center">EMAIL</th>
        <th class="bg-white text-center">COUNTRY</th>
        <th class="bg-white text-center">MOBILE</th>
        <th class="bg-white text-center">PACKAGE</th>
        <th class="bg-white text-center">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let pac of bookings">
        <td class="font-weight-bold text-center">
          {{pac.bookingRef}}
        </td>
        <td class="font-weight-bold text-center">
          {{pac.customer.clientName}}
        </td>
        <td class="font-weight-bold text-center">
          {{pac.customer.clientEmail}}
        </td>
        <td class="text-center">
          <span style="font-size: 15px" class="badge bg-neutral-danger text-danger">
            {{pac.customer.country}}
          </span>
        </td>
        <td class="font-weight-bold text-center">
          {{pac.customer.mobileNumber}}
        </td>
        <td class="font-weight-bold text-center">
          {{pac.airTicket.destination.country}} - {{pac.airTicket.origin.country}}
        </td>
        <td *ngIf="pac.travelPackage!=null" class="font-weight-bold text-center">
          {{pac.travelPackage.packageCategory.category}}
        </td>

        <td class="text-center" *ngIf="pac.status==0">
          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">
            <!--            <button type="button" class="btn btn-warning" (click)="userUpdate(user)"><i class="fas fa-upload"></i></button>-->
            <button type="button" class="btn btn-success" (click)="openModal(successModal,pac.id)"><i
              class="fas fa-check-circle"></i></button>
            <button type="button" class="btn btn-danger" (click)="openModal(errorModal,pac.id)"><i
              class="fas fa-times-circle"></i></button>

          </div>
        </td>

        <td class="text-center" *ngIf="pac.status==1">
          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">
            <!--            <button type="button" class="btn btn-warning" (click)="userUpdate(user)"><i class="fas fa-upload"></i></button>-->
            <button type="button" class="btn btn-neutral-success"><i class="fas fa-check-circle"></i></button>
          </div>
        </td>

        <td class="text-center" *ngIf="pac.status==9">
          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">
            <!--            <button type="button" class="btn btn-warning" (click)="userUpdate(user)"><i class="fas fa-upload"></i></button>-->
            <button type="button" class="btn btn-neutral-danger"><i class="fas fa-times-circle"></i></button>
          </div>
        </td>
      </tr>

      </tbody>
    </table>
    <div class="card-footer py-3 d-flex justify-content-between">
      <pagination [totalItems]="totalRec" [(ngModel)]="currentPage" (pageChanged)="getAll($event.page)"
                  class="pagination-icons pagination-warning"></pagination>
    </div>

  </div>
  <div class="card-footer py-3 d-flex justify-content-between">

  </div>
</div>

<ng-template #successModal>
  <div class="text-center p-5">
    <div class="avatar-icon-wrapper rounded-circle m-0">
      <div
        class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-success text-success m-0 d-130">
        <fa-icon [icon]="['far', 'lightbulb']" class="d-flex align-self-center display-3"></fa-icon>
      </div>
    </div>
    <h4 class="font-weight-bold mt-4">Do you want to CONFIREM this?</h4>
    <p class="mb-0 font-size-lg text-muted">You can later review your options.</p>
    <div class="pt-4">
      <button (click)="declineConfirem()" class="btn btn-pill btn-neutral-dark mx-1" type="button">
                <span class="btn-wrapper--label">
                    Cancel
                </span>
      </button>
      <button (click)="confirmConfirem()" class="btn btn-pill btn-success mx-1" type="button">
                <span class="btn-wrapper--label">
                    Confirem
                </span>
      </button>
    </div>
  </div>
</ng-template>


<ng-template #errorModal>
  <div class="text-center p-5">
    <div class="avatar-icon-wrapper rounded-circle m-0">
      <div
        class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-danger text-danger m-0 d-130">
        <fa-icon [icon]="['fas', 'times']" class="d-flex align-self-center display-3"></fa-icon>
      </div>
    </div>
    <h4 class="font-weight-bold mt-4">Are you sure you want to CANCEL this entry?</h4>
    <p class="mb-0 font-size-lg text-muted">You cannot undo this operation.</p>
    <div class="pt-4">
      <button (click)="declineCancel()" class="btn btn-pill btn-neutral-secondary mx-1" type="button">
                <span class="btn-wrapper--label">
                    Cancel
                </span>
      </button>
      <button (click)="confirmCancel()" class="btn btn-pill btn-danger mx-1" type="button">
                <span class="btn-wrapper--label">
                    Delete
                </span>
      </button>
    </div>
  </div>
</ng-template>
<notifier-container></notifier-container>
